import Functions from './../functions.js';
//import Scrollbar from "smooth-scrollbar";

export default {
  init() {

    $(".btn-menu-open").on("click", function (ev) {
      if ($("body").hasClass("menu-open")) {
        $("body").removeClass("menu-open");
      } else {
        $("body").addClass("menu-open");
      }
      ev.stopPropagation();
    });

    $("#menu-collapse nav.menu").on("click", function (ev) {
      ev.stopPropagation();
    });

    $("#menu-collapse input").on("click", function (ev) {
      ev.stopPropagation();
    });

    $("header.banner input").on("click", function (ev) {
      ev.stopPropagation();
    });

    $("#menu-collapse nav.menu li.menu-item-has-children > a").on("click", function (ev) {
      if (!$(this).parent().hasClass("menu-item-open")) {
        if (window.innerWidth < 992) {
          if ($(this).parent().hasClass("menu-item-open")) {
            $(this).parent().removeClass("menu-item-open")
          } else {
            $(this).parent().addClass("menu-item-open")
          }
          ev.preventDefault();
          ev.stopPropagation();
          return false;
        }
      }
    });

    $("body").on("click", function () {
      $("body").removeClass("menu-open");
    });

    $("select.select2").select2({
      minimumResultsForSearch: 'Infinity',
    });

    $(window).resize(function () {
      $("select.select2").select2({
        minimumResultsForSearch: 'Infinity',
      });
    });


    $(".wrap_video, .lien_modal_video").on('click', function () {
      var theModal = $(this).data("target"),
        videoSRC = $(this).attr("data-theVideo"),
        videoSRCauto = videoSRC + "?autoplay=1";
      $(theModal + ' iframe').attr('src', videoSRCauto);
    });

    $("#videoModal").on('hidden.bs.modal', function () {
      $('#videoModal iframe').attr('src', "");
    });

    Functions.scrollbarEvent();
    $(window).scroll(function () {
      Functions.scrollbarEvent();
    });


    Functions.scrollbar = $('#main-scrollbar'); //Scrollbar.init(document.querySelector('#main-scrollbar'), {damping: 0.1, wheelEventTarget: null});



    setTimeout(function () {
      if (window.location.hash)
        $('a[aria-controls=' + window.location.hash.slice(1) + ']').click();

    }, 1000);

    jQuery('a[href^="#"]:not(a[aria-controls])').on("click", function () {
      let hash = jQuery(this).attr("href").split('#');

      if (hash[1]) {
        if (jQuery('a.collapsed[aria-controls=' + hash[1] + ']').length) {
          jQuery('a[aria-controls=' + hash[1] + ']').click();
        }
      }
    });

    // JavaScript to be fired on all pages

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired


  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js